/* eslint-disable jsx-a11y/anchor-has-content */
import React from 'react';
import { Link } from 'gatsby';
import FooterFr from '../images/fr-footer.png';
import { useFooterMenuitems } from '../hooks/getFooterMenuItems';
import { useSocialLinks } from '../hooks/getSocialLinks';
import { useFooterContent } from '../hooks/getFooterContent';

function MenuItemLink(data) {
    if (data.type === 'custom') {
        return (
            <a href={data.path} target="_blank" rel="noopener noreferrer">
                {data.title}
            </a>
        );
    }
    if (data.type === 'post_type') {
        const postTypeUrl = data.url
            .split('https://werockthespectrumberwickvic.wrtsfranchise.com/')
            .pop();
        return <Link to={`/${postTypeUrl}`}>{data.title}</Link>;
    }
}

const Footer = () => {
    const menuItems = useFooterMenuitems();
    const socialLinks = useSocialLinks();
    const footerContent = useFooterContent();
    return (
        <>
            <footer>
                <div className="footaddress">
                    <h2>
                        {footerContent.footer_address}
                        {` `}
                        <span className="ipadhide">|</span>
                        {` `}
                        <span className="yellowtxt">
                            CALL US: {footerContent.footer_phone_number}
                        </span>
                    </h2>
                </div>

                <h3 className="footinst">
                    FOLLOW US ON INSTAGRAM {` `}
                    <a
                        className="yellowtxt"
                        href={socialLinks.social_instagram_link}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        @wrtsberwickau
                    </a>
                </h3>
                <h3 className="footinst">
                    FOLLOW US ON FACEBOOK {` `}
                    <a
                        className="yellowtxt"
                        href={socialLinks.social_facebook_link}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        @wrtsberwick
                    </a>
                </h3>

                <div className="footer-nav">
                    {menuItems.map(menuItem => (
                        <MenuItemLink
                            path={menuItem.url}
                            url={menuItem.url}
                            title={menuItem.title}
                            type={menuItem.type}
                            hasChildren={menuItem.wordpress_children}
                            key={menuItem.wordpress_id}
                        />
                    ))}
                </div>
            <div className="sign-box-up">
                <p className="sign-box-up-par"><span>JOIN OUR NEWSLETTER!</span><br />Subscribe to get the latest updates on events, classes, and more!</p>
                    <a
                        className="signup-letter-new"
                        href="https://axle.ws/1Y6sR/subscribe/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >SUBSCRIBE</a>
                    </div> 
                    <div className="flex-box-foo">
                    <div className="flags-box">
                    <img className="footerflag shiny" src={ 'https://werockthespectrumwollongong.wrtsfranchise.com/wp-content/uploads/2022/11/Flag_Graphic_2.png' } alt="footer fr"   /><img className="footerflag" src={ 'https://werockthespectrumwollongong.wrtsfranchise.com/wp-content/uploads/2022/11/Flag_Graphic_1.png' } alt="footer fr"   />
                <p className="sign-box-up-par">We Rock the Spectrum acknowledges Aboriginal and Torres Strait Islander people as the traditional custodians of country throughout Australia, respecting their connections to land, sea and community.</p>
               
                    </div>
                    <div className="flags-box">
                  
                <img className="footerflag shiny" src={ 'https://werockthespectrumwollongong.wrtsfranchise.com/wp-content/uploads/2022/11/Neurodiversity_Symbol.png' } alt="footer fr"   />
                <p className="sign-box-up-par">We Rock the Spectrum is committed to an inclusive community, celebrating differences and accepting diversity.</p>
                    </div>
</div> <p className="white-a"><a href="https://www.werockthespectrumprestonvic.com.au/complaints-and-feedback/" target="_blank">Complaints and Feedback</a><br />
<a href="https://www.werockthespectrumprestonvic.com.au/policies/" target="_blank">Policies</a></p>
                <div className="headersocial footsoc soc">
                    <a
                        className="soc-facebook"
                        href={socialLinks.social_facebook_link}
                        target="_blank"
                        rel="noopener noreferrer"
                    ></a>
                    <a
                        className="soc-instagram"
                        href={socialLinks.social_instagram_link}
                        target="_blank"
                        rel="noopener noreferrer"
                    ></a>
                    {/* <a
                        className="soc-twitter"
                        href={socialLinks.social_twitter_link}
                        target="_blank"
                        rel="noopener noreferrer"
                    ></a>
                    
                    <a
                        className="soc-pinterest"
                        href={socialLinks.social_pinterest_link}
                        target="_blank"
                        rel="noopener noreferrer"
                    ></a> */}
                    
                </div>
                <a
                    href="http://www.franchiseregistry.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img className="footerfr" src={ 'https://werockthespectrumkidsgym.wrtsfranchise.com/wp-content/uploads/2022/07/FRANdata_FranchiseRegistryMember_Logo_2022.png' } alt="footer fr" />
                </a>
            </footer>
        </>
    );
};
export default Footer;

